import moment from "moment";

import { axios } from "../../cores/axiosWrapper";
import queryString from "../../cores/queryString";
import dayjs from "dayjs";

const TEXT_MATCH_TYPES = ["TEXT_FIELD", "TEXT_AREA"];

function getAssetsAPI(stageId, apiEndpoint, projectId, query) {
    let queries = {
        generateAccessUrl: true,
    };

    if (query.offset) queries.offset = query.offset;
    if (query.limit) queries.limit = query.limit;
    if (query.withAutoArchiveDate) queries.withAutoArchiveDate = query.withAutoArchiveDate;
    if (query.includeShareInfo) queries.includeShareInfo = query.includeShareInfo;
    if (query.isNotIngestType) queries.isNotIngestType = query.isNotIngestType;

    if (query.isQuickSearch) {
        queries.q = query.keyword;
        if (query.folderPath) {
            queries.folderPath = query.folderPath;
            if (query.isFolderSearch) {
                queries.isFolderSearch = query.isFolderSearch;
            }
        }

        if (query.categoryGroupId) {
            queries.categoryGroupId = query.categoryGroupId;
            if (query.isNotCategoryIds) {
                queries.isNotCategoryIds = query.isNotCategoryIds;
                queries.categoryIds = "-1";
            }
        } else {
            if (query.isNotCategoryIds) {
                queries.isNotCategoryIds = query.isNotCategoryIds;
                queries.categoryIds = "-1";
            }

            if (query.categoryIds && query.categoryIds.length > 0) {
                queries.categoryIds = query.categoryIds
                    .map((c) => {
                        if (typeof c === "object") return c.id;
                        return c;
                    })
                    .join(",");
            }

            if (query.isIncludeChildCategory) queries.isIncludeChildCategory = query.isIncludeChildCategory;
        }

        if (query.virtualFolderId) queries.virtualFolderId = query.virtualFolderId;
        if (query.contentSchema?.id) queries.contentSchemaId = query.contentSchema.id;
    } else {
        if (query.folderPath) {
            queries.folderPath = query.folderPath;
            if (query.isFolderSearch) {
                queries.isFolderSearch = query.isFolderSearch;
            }
        }
        if (query.name) queries.name = query.name;
        if (query.id) queries.id = query.id;
        if (query.ids) queries.ids = query.ids;
        if (query.description) queries.description = query.description;
        if (query.creator) queries.creator = query.creator;
        if (query.owner) queries.ownerId = query.owner.id;
        if (query.status) queries.status = query.status;
        if (query.jobId) queries.jobId = query.jobId;
        if (query.ingestType) queries.ingestType = query.ingestType;
        if (query.types) queries.types = query.types.join(",");
        if (query.extensions) queries.extensions = query.extensions && query.extensions.join(",");
        if (query.mediaTypes && query.mediaTypes.length > 0)
            queries.mediaTypes = query.mediaTypes && query.mediaTypes.join(",");
        if (query.categoryGroupId) {
            queries.categoryGroupId = query.categoryGroupId;
            if (query.isNotCategoryIds) {
                queries.isNotCategoryIds = query.isNotCategoryIds;
                queries.categoryIds = "-1";
            }
        } else {
            if (query.categoryIds && query.categoryIds.length > 0)
                queries.categoryIds = query.categoryIds
                    .map((c) => {
                        if (typeof c === "object") return c.id;
                        return c;
                    })
                    .join(",");
            if (query.isNotCategoryIds) {
                queries.isNotCategoryIds = query.isNotCategoryIds;
                queries.categoryIds = "-1";
            }
            if (query.isIncludeChildCategory) queries.isIncludeChildCategory = query.isIncludeChildCategory;
        }

        if (query.tags) queries.tags = "";
        if (query.tags !== undefined && query.tags.length > 0) {
            query.tags.forEach((tag, index) => {
                index === 0 ? tag : (tag = `,${tag}`);
                queries.tags += tag;
            });
        }

        if (query.beginDuration || query.endDuration) {
            const begin = query.beginDuration ?? "00:00:00";
            const end = query.endDuration ?? "99:99:99";
            queries.duration = `${moment.duration(begin).asMilliseconds()}~${
                moment.duration(end).asMilliseconds() + 999
            }`;
        }

        if (query.startAt && query.endAt) {
            const startAt = query.startAt;
            const endAt = query.endAt;

            queries.createdAt = `${startAt}~${endAt}`;
        }
        if (query.videoId) queries.videoId = query.videoId;
        if (query.peopleId) queries.peopleId = query.peopleId;
        if (query.hasAssociations) queries.hasAssociations = query.hasAssociations;
        if (query.fileMeta) {
            queries.fileMeta = query.fileMeta;
        }
        if (query.virtualFolderId) queries.virtualFolderId = query.virtualFolderId;
        if (query.contentSchema?.id) queries.contentSchemaId = query.contentSchema.id;
        if (query.contentFields && query.contentFields.length > 0) {
            let customFields = "";
            query.contentFields?.forEach((field) => {
                const { fieldId, value } = field;
                if (value) {
                    if (customFields === "") customFields = `${fieldId}:${value}`;
                    else customFields = `${customFields},${fieldId}:${value}`;
                }
            });
            queries.contentFields = customFields;
        }
        if (query.archiveStatus) queries.archiveStatus = query.archiveStatus;
        if (query.isOwnerLocked) queries.isOwnerLocked = query.isOwnerLocked;
        if (query.indexDocStatus?.length > 0) {
            // '진행 중'(PENDING) 묶음의 펼치기는 호출부(thunk)가 withExpandedIndexDocStatus 로 끝냈다.
            queries.indexDocStatus = query.indexDocStatus.join(",");
        }
    }
    if (query.favoritesBy) {
        queries.myFavorite = true;
    }

    return axios.get(`${apiEndpoint}/assets?${queryString.stringify(queries)}`, {
        headers: {
            stageId,
            projectId,
        },
    });
}

function getIntegratedSearchKeywordAssetsAPI(stageId, apiEndpoint, projectId, params) {
    return axios.get(`${apiEndpoint}/v2/integrated-search`, {
        params,
        headers: {
            stageId,
            projectId,
        },
    });
}

function getIntegratedSearchAssetsAPI(stageId, apiEndpoint, projectId, query) {
    let conditionGroups = [];
    let conditions = [];

    function addMilliseconds(dateString, type) {
        // 이미 밀리초가 있는 경우를 처리하기 위한 정규식
        if (dateString.match(/\.\d{3}Z$/)) {
            return dateString;
        }
        if (type === "startAt") return dateString.replace(/Z$/, ".000Z");
        else return dateString.replace(/Z$/, ".999Z");
    }

    Object.keys(query).forEach((key) => {
        let condition;
        if (key === "mediaTypes" && query[key].length > 0) {
            condition = { type: "TERM", key: "metadata.mediaType", values: query[key] };
        } else if (key === "folderPath") {
            condition = { type: "TERM", key: "metadata.folderPath", values: [query[key]] };
        } else if (key === "name") {
            condition = { type: "MATCH", key: "metadata.name", values: [query[key]] };
        } else if (key === "id" && query[key]) {
            condition = { type: "TERM", key: "metadata.id", values: [query[key]] };
        } else if (key === "description") {
            condition = { type: "MATCH", key: "metadata.description", values: [query[key]] };
        } else if (key === "createdBy") {
            condition = { type: "TERM", key: "metadata.createdById", values: [query[key]] };
        } else if (key === "owner") {
            condition = { type: "TERM", key: "metadata.ownerId", values: [query[key]?.id] };
        } else if (key === "types") {
            condition = { type: "TERM", key: "metadata.type", values: query[key] };
        } else if (key === "extensions") {
            condition = { type: "TERM", key: "metadata.extensions", values: query[key] };
        } else if (key === "categoryIds" && query[key].length > 0) {
            const values = query.categoryIds.map((c) => {
                if (typeof c === "object") return c.id;
                return c;
            });
            condition = { type: "TERM", key: "metadata.categoryIds", values };
        } else if (key === "tags" && query[key].length > 0) {
            condition = { type: "TERM", key: "metadata.tags", values: query[key] };
        } else if (key === "attributions" && query[key].length > 0) {
            const attributions = query[key].filter((el) => !!el.key || !!el.value);
            attributions.map((a) => {
                let conditions = [];
                if (a.key) {
                    const condition = {
                        type: "TERM",
                        key: "metadata.attributions.key",
                        values: [a.key],
                    };
                    conditions.push(condition);
                }
                if (a.value) {
                    const condition = {
                        type: "TERM",
                        key: "metadata.attributions.value",
                        values: [a.value],
                    };
                    conditions.push(condition);
                }
                conditionGroups.push({ conditions, operator: "must" });
            });
        } else if (key === "contentSchema" && query[key]?.id) {
            condition = { type: "TERM", key: "metadata.customMetadataSchemaId", values: [query.contentSchema.id] };
        } else if (key === "contentFields" && query[key].length > 0) {
            const fields = query.contentFields.filter((field) => field.value);
            fields.forEach((field) => {
                let conditions = [];
                const conditionField = {
                    type: "TERM",
                    key: "metadata.customMetadata.fieldId",
                    values: [field.fieldId],
                };
                const conditionValue = {
                    type: TEXT_MATCH_TYPES.includes(field.fieldType ?? "") ? "MATCH" : "TERM",
                    key: "metadata.customMetadata.value",
                    values: [field.value],
                };
                conditions.push(conditionField, conditionValue);
                conditionGroups.push({ conditions, operator: "must" });
            });
        } else if (key === "favoritesBy") {
            condition = { type: "TERM", key: "metadata.favoritesBy", values: [query.favoritesBy] };
        } else if (key === "isNotIngestType") {
            condition = { type: "TERM", key: "metadata.ingestType", values: ["REMOTE", "DIRECT"] };
        }
        if (condition) {
            conditions.push(condition);
        }
    });

    if (query.startAt && query.endAt) {
        const startAt = addMilliseconds(query.startAt, "startAt");
        const endAt = addMilliseconds(query.endAt, "endAt");
        const condition = {
            type: "RANGE",
            key: "metadata.createdAt",
            values: [dayjs(startAt).toISOString(), dayjs(endAt).toISOString()],
        };
        conditions.push(condition);
    }

    if (conditions.length > 0) conditionGroups.push({ conditions, operator: "must" });

    const queries = { size: query.limit };
    if (query.projectIds) queries.projectIds = query.projectIds.map((p) => p.id);

    if (query.nextToken) queries.token = query.nextToken;
    if (conditionGroups.length > 0) queries.conditionGroups = conditionGroups;

    const headers = { stageId };
    if (projectId) headers.projectId = projectId;

    return axios.post(`${apiEndpoint}/v2/integrated-search/asset`, queries, {
        headers,
    });
}

function deleteAssetAPI(stageId, apiEndpoint, projectId, id, version) {
    return axios.delete(`${apiEndpoint}/assets/${id}`, {
        params: {
            version,
            deleteAIJobs: true,
        },
        headers: {
            stageId,
            projectId,
        },
    });
}

function listAssetTypesAPI(stageId, apiEndpoint, projectId) {
    return axios.get(`${apiEndpoint}/assets/types`, {
        headers: {
            stageId,
            projectId,
        },
    });
}

function listAssetExtensionsAPI(stageId, apiEndpoint, projectId) {
    return axios.get(`${apiEndpoint}/assets/extensions`, {
        headers: {
            stageId,
            projectId,
        },
    });
}

/**
 * Bulk Insert AssetCategoryMapper API
 * @param {string} stageId
 * @param {string} apiEndpoint
 * @param {string} projectId
 * @param {array} assets - asset list
 * @param {array} categories - category list
 */
function bulkAttachCategoriesToAssetAPI(stageId, apiEndpoint, projectId, assets, categories) {
    return axios.post(
        `${apiEndpoint}/assets/categories/bulk`,
        { assets, categories },
        {
            headers: {
                stageId,
                projectId,
            },
        },
    );
}

/**
 * Bulk Delete AssetCategoryMapper API
 * @param {string} stageId
 * @param {string} apiEndpoint
 * @param {string} projectId
 * @param {array} assets - asset list
 * @param {array} categories - category list
 */
function bulkDetachCategoriesToAssetAPI(stageId, apiEndpoint, projectId, assets, categories) {
    return axios.delete(`${apiEndpoint}/assets/categories/bulk`, {
        data: { assets, categories },
        headers: {
            stageId,
            projectId,
        },
    });
}

const getUsersInfoAPI = (apiEndpoint, projectId, userIds) => {
    return axios.get(`${apiEndpoint}/users/${userIds}`, {
        headers: { projectId },
    });
};

const moveAssetsFolderAPI = (stageId, apiEndpoint, projectId, data) => {
    return axios.post(`${apiEndpoint}/assets:move`, data, {
        headers: {
            stageId,
            projectId,
        },
    });
};

const archiveAssetAPI = ({ apiEndpoint, projectId, data }) => {
    return axios.post(`${apiEndpoint}/assets:archive`, data, {
        headers: {
            projectId,
        },
    });
};

const restoreAssetAPI = ({ apiEndpoint, projectId, data }) => {
    return axios.post(`${apiEndpoint}/assets:restore`, data, {
        headers: {
            projectId,
        },
    });
};

const getAssetOwnersAPI = ({ apiEndpoint, projectId, params }) => {
    return axios.get(`${apiEndpoint}/assets/owners`, {
        params,
        headers: {
            projectId,
        },
    });
};

const updateAssetsOwnerAPI = (stageId, apiEndpoint, projectId, data) => {
    return axios.post(`${apiEndpoint}/assets:owner-update`, data, {
        headers: {
            stageId,
            projectId,
        },
    });
};

export {
    getAssetsAPI,
    getIntegratedSearchKeywordAssetsAPI,
    getIntegratedSearchAssetsAPI,
    deleteAssetAPI,
    listAssetTypesAPI,
    listAssetExtensionsAPI,
    bulkAttachCategoriesToAssetAPI,
    bulkDetachCategoriesToAssetAPI,
    getUsersInfoAPI,
    moveAssetsFolderAPI,
    archiveAssetAPI,
    restoreAssetAPI,
    getAssetOwnersAPI,
    updateAssetsOwnerAPI,
};

export default {
    getAssetsAPI,
    deleteAssetAPI,
    listAssetTypesAPI,
    listAssetExtensionsAPI,
    bulkAttachCategoriesToAssetAPI,
    bulkDetachCategoriesToAssetAPI,
    getUsersInfoAPI,
    moveAssetsFolderAPI,
    archiveAssetAPI,
    restoreAssetAPI,
};
